// extracted by mini-css-extract-plugin
export default {"loadingSpinner":"UwKYfEVX","spinner":"nNMnpoMN","ant-spin-dot-item":"ant-spin-dot-item","bgWhite":"Ix0raSFW","loadingSpinnerNoMask":"T0IpPQK1"};